import { createBrowserHistory } from 'history';

export enum ROUTES {
  ROOT = '/',
  ADMIN_AUTH= '/auth',
  CONTRACTOR_AUTH =  '/auth/contractor',
  CONTRACTOR_BASE = '/contractor',
  ADMIN_BASE = '/admin',
  ADMIN_DASHBOARD = '/admin/dashboard',
  CONTRACTOR_DASHBOARD = '/contractor/dashboard',
  PAYMENTS_BASE = 'payments/request-local',
  PAYMENTS_GOAL = 'payments/request-goal',
  SUCCESS = 'done',
  FAILURE = 'error',
  RESET_PASSWORD = '/reset-password'

}

const history = createBrowserHistory({window});

const navigateTo = (route: string) => {
  console.log(route);
  history.push(route);
};

export { navigateTo, history };
